// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginPage_wrapper__b7+yS","header":"LoginPage_header__evclM","card":"LoginPage_card__SHGPG","companyName":"LoginPage_companyName__OUrNv"};